<template>
  <div class="seomain">
    <div class="info-main">
      <div class="info-top"><span>拆解工单：</span>{{ stinfo.order_code }}</div>
      <!-- <div class="info-mid"><h1>{{stinfo.product_sku}}</h1><p>拆解SKU</p></div> -->
      <div class="info-bottom text-center">
        <dl>
          <dt>拆解日期</dt>
          <dd>{{ stinfo.starttime }}</dd>
        </dl>
        <dl>
          <dt>拆解数量</dt>
          <dd>{{ stinfo.quantity }}</dd>
        </dl>
      </div>
    </div>

    <div class="tab-content">
      <div class="st-list-box pan-105">
        <div class="st-list" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="st-list-top">
            <div class="t-tit">{{ v.sku ? v.sku : "暂无sku" }}</div>
          </div>
          <div class="st-list-main">
            <p>产品名称：{{ v.product_name }}</p>
            <p>库存编码：{{ v.inventory_code }}</p>
            <p>制造方编码：{{ v.product_manufacturercode }}</p>
            <p>型号：{{ v.product_model }}</p>
            <p>货架号：{{ v.inventory_position }}</p>
            <p>总数量：{{ v.quantity }}</p>
            <p>已备货数量：{{ v.receive }}</p>
            <p>已签收数量：{{ v.to_receive }}</p>
            <van-field v-model="v.stnum" type="tel" label="签收数量" placeholder="请输入签收数量" />
          </div>
          <div class="st-list-bottom-diy" v-if="flag != 'false'">
            <!-- <div class="st-diyl-btn" @click="show_detail_box(v.id)">
              <p class="st-opt-btn">申请领料</p>
            </div> -->
            <div class="st-diyr-btn">
              <router-link :to="'/disassembly/main/' + v.id" class="st-opt-btn">拆 卸</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 一键入库 -->
    <div class="footer pf-btm">
      <div class="btn" @click="submit()" v-if="flag != 'false'">
        提交签收
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialog_num: "",
      show: !1,
      stlist: [],
      stinfo: {},
      oneinfo: {},
      paramsid: 0,
      activeid: 0,
    };
  },
  watch: {},
  computed: {
    flag() {
      return this.$route.params.flag;
    },
  },
  methods: {
    get_st_info: function() {
      let paramsid = this.$route.params.id;
      this.$post(this.$api.stGetChaigongInfo, { id: paramsid }).then((res) => {
        this.stinfo = res.data.info;
        this.stlist = res.data.list.filter((item) => {
          item.stnum = "";
          return item;
        });
      });
    },
    // 过滤无效数据
    rulesSubmitForm(dataList) {
      return dataList.filter((item) => {
        if (item.stnum > 0) {
          return item;
        }
      });
    },
    // 提交签收
    async submit() {
      let dataForm = this.rulesSubmitForm(this.stlist);
      console.log(dataForm.length);
      if (dataForm.length == 0) return this.$toast.fail("请填写必要字段");
      let params = [];
      dataForm.map((item) => {
        let obj = {};
        obj.id = item.id;
        obj.stnum = item.stnum;
        params.push(obj);
      });
      console.log(params);
      let result = await this.$post(this.$api.stGetChaigongEdit, params);
      this.$toast.success("提交成功");
      this.get_st_info();
    },
  },
  created() {
    this.get_st_info();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "拆工" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.info-main {
  padding-top: 10px;
  background: #345;
  margin-bottom: 15px;
}
.info-main .info-top {
  color: #9ab;
  line-height: 2;
  margin: 0 20px;
}
.info-main .info-mid {
  text-align: center;
  color: #fff;
}
.info-main .info-mid h1 {
  line-height: 2.2;
  font-weight: normal;
}
.info-main .info-mid p {
  color: #9ab;
}
.info-main .info-bottom {
  display: flex;
  background: #2f3e50;
  border-top: 1px solid #9ab;
  margin-top: 20px;
  padding: 5px 0;
}
.info-main .info-bottom dl {
  flex: 1;
  line-height: 1.8;
}
.info-main .info-bottom dt {
  color: #9ab;
}
.info-main .info-bottom dd {
  color: #fff;
}

.info-scan {
  margin-top: 2.5em;
  margin-right: 1.5em;
}
.info-scan .van-icon {
  color: #0ba;
  font-size: 50px;
}

.info-detail-list {
  padding: 10px 20px;
  background: #fff;
}
.info-detail-list dl {
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  line-height: 30px;
  padding-top: 10px;
  padding-bottom: 5px;
}
.info-detail-list dt {
  flex: 1;
}
.info-detail-list .num {
  padding: 0 10px;
}
.info-detail-list .icon {
  color: #ddd;
  font-weight: bolder;
  font-size: 24px;
}

.status-00 {
  font-weight: normal;
}
.status-01 {
  color: #43cf7c;
}
.status-02 {
  color: #ff5733;
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #3c8dbc;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
.van-cell.van-field {
  padding: 7px 0;
}
.seomain .tab-content {
  box-sizing: border-box;
  padding-bottom: 50px;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 5px 16px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #cccccc;
  background-color: #fff;
}
.seomain .pf-btm .btn {
  box-sizing: border-box;

  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 16px;
  background-color: #00baad;
}
</style>
